/**
 * Gradient button style — used for high-priority actions (create order, make payment).
 * Applies a primary gradient background, hover lift, active press, and shine-ready overflow.
 */
const superButtonStyle = [
  'group rounded-lg text-base font-bold',
  '!bg-gradient-to-r !from-primary-500 !via-primary-600 !to-primary-700',
  'hover:!from-primary-400 hover:!via-primary-500 hover:!to-primary-600',
  'shadow-lg hover:shadow-2xl transition-all duration-300',
  'transform hover:scale-[1.02] active:scale-[0.98]',
  'border-0 !text-white relative overflow-hidden',
].join(' ');

/**
 * Shine overlay class — place a <span> with this class inside a `group` button
 * to get a left-to-right shine sweep on hover.
 */
const superButtonShine =
  'absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000';

export const buttonsColors = {
  /** Unique gradient style mainly used for very important actions such as creating order or making a payment. */
  superButtonStyle,
  /** Shine overlay for superButtonStyle. */
  superButtonShine,
};
